export default [
    {
        path: '/return-goods/entry/:customerNumber?',
        name: 'return_goods_entry',
        component: () => import('@src/return-goods/return-goods-entry.vue'),
        meta: {
            title: 'Retourenannahme',
            role: 'ROLE_RETURN_GOODS_ENTRY',
        },
        props(route) {
            if (!route.params.customerNumber) {
                return;
            }
            return { customerNumber: route.params.customerNumber };
        },
    },
    {
        path: '/return-goods/revocation-entry/:id',
        name: 'return_goods_revocation_entry',
        component: () => import('@src/return-goods/revocation-entry.vue'),
        meta: {
            title: 'Retourenannahme',
            role: 'ROLE_RETURN_GOODS_ENTRY',
        },
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
    },
    {
        path: '/return-goods/claim-asset-entry/:id',
        name: 'return_goods_claim_asset_entry',
        component: () => import('@src/return-goods/claim-asset-entry.vue'),
        meta: {
            title: 'Retourenannahme',
            role: 'ROLE_RETURN_GOODS_ENTRY',
        },
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
    },
    {
        path: '/return-goods/expected-returns/missing-label',
        name: 'return_goods_expected_returns_missing_label',
        component: () => import('@src/return-goods/expected-returns-missing-label.vue'),
        meta: {
            title: 'Anzulegende Rücksendungen',
            role: 'ROLE_EXPECTED_RETURN_LIST',
        },
    },
    {
        path: '/return-goods/settings/entry',
        name: 'return_goods_settings_entry_mail',
        component: () => import('@src/return-goods/retrun-goods-entry-settings.vue'),
        meta: {
            title: 'Retourenannahme - Einstellungen',
            role: 'ROLE_EDIT_RETURN_GOODS_ENTRY_SETTINGS',
        },
    },
    {
        path: '/return-goods/expected-return-receive',
        name: 'return_goods_expected_returns_receive',
        component: () => import('@src/return-goods/expected-return-receive.vue'),
        meta: {
            title: 'Retourenempfang',
            role: 'ROLE_EXPECTED_RETURN_RECEIVE',
        },
    },
];
